/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {AbmsBoardSubspecialtyService} from './abms-board-subspecialty.service';

@NgModule({
    providers: [
        AbmsBoardSubspecialtyService
    ]
})
export class AbmsBoardSubspecialtyModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.module.ts